export default {
  init() {


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
      $(document).on('click', 'a[href*="#"]:not([data-vc-tabs]):not(.sandwich-icon)', function(e) {
          e.preventDefault();
          var target = $(this).attr('href');
          var animating = false;

          if (target.charAt(0) != '#') {
              target = target.split('#');
              target = '#' + target[1];
          }
          if ($(target).hasClass('vc_tta-panel'))
              // e.preventDefault()
              return

          if ($(this).parents('.comment-navigation').length) {
              return true;
          }


          if (animating || $(this).hasClass('ui-tabs-anchor'))
              return false;



          if ($(target).length > 0) {
              e.preventDefault();
              animating = true;

              var menu_open = $('.side-menu').hasClass('open');
              var timeout = 10;

              if (menu_open) {
                  $('.side-menu.open .menu-toggle-off').click();
                  timeout = 400;
              }

              setTimeout(function() {

                  var topPosition = $(target).offset().top;

                  if( jQuery('.classic-menu').length ){
                      if( jQuery('.classic-menu').hasClass('responsive') ){
                          topPosition = topPosition - jQuery('.responsive-header').outerHeight();
                      }
                  }


                  animating = true;
                  $('html, body').animate({
                      scrollTop: topPosition,
                  }, 800, function() {

                      animating = false;
                  });

              }, timeout);

          }

      });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js